import parsePhoneNumberFromString from "libphonenumber-js";

export function isValidPhoneNumber(phoneNumber) {
    const parsed = parsePhoneNumberFromString(phoneNumber, 'RU');

    if (!parsed) return false;

    if (!parsed.isValid()) return false;

    const number = parsed.number;

    // Блокируем нереалистичные шаблоны
    const badNumbers = [
        '+79000000000',
        '+79999999999',
        '+77777777777'
    ];

    return !badNumbers.includes(number);
}

export function isValidPhoneLength(phoneNumber) {
    const digits = phoneNumber.replace(/\D/g, '');
    return digits.length === 11;
}
